<template>
  <header id="HViewer">
    <section class="HVContent">
      <div class="HVCompanyMarca" id="HVCompanyMarca" @click="redirectUrlBase">
        <img src="../assets/img/logo.png" class="logoCompany" />
      </div>

      <div class="HVDocumentName" id="HVDocumentName">
        <a alt="titulo do documento dentro do digital doc">
          <i class="icon-file mg-right"></i>
          {{title}}
        </a>
      </div>

      <div class="HVToolbarButtons">
        <button
          v-if="(canDownload || canDownloadWatermark) && !isPublic"
          @click="download"
          id="HVPrinter"
          class="btnPinter">
          <i class="icon-download"></i>
        </button>

        <button
          v-if="(canPrint || canPrintSampleWatermark || canPrintWatermark || canPrintWatermarkRevisionHistory) && !isPublic"
          @click="print"
          id="HVPrinter"
          class="btnPinter">
          <i class="icon-printer"></i>
        </button>
      </div>
    </section>
  </header>

</template>
<script>
export default {
  name: "VHeader",
  props: {
    url:String,
    title: String,
    canPrint: Boolean,
    oldRevision: Boolean,
    canDownload: Boolean,
    isPublic: Boolean,
    ownerRevision: Boolean,
    canPrintWatermark: Boolean,
    canDownloadWatermark: Boolean,
    canPrintSampleWatermark: Boolean,
    canPrintWatermarkRevisionHistory: Boolean,
    revisionData: Object
  },

  methods: {
    redirectUrlBase() {
      if (this.revisionData)
        window.location.href = this.revisionData.infos.urlBase;
    },

    async print() {
      const rev = this.revisionData;

      // Log the revision data
      console.log('Revision Data:', rev);

      if (!rev) {
        console.log('No revision data available.');
        return;
      }

      // Check if oldRevision is present and if watermark revision history can be printed
      if ((this.oldRevision && !this.canPrintWatermarkRevisionHistory) || (this.canPrintWatermark && !this.ownerRevision)) {
        console.log('Condition met for printing document with watermark.');
        this.printDocWatermark();
      }
      // Check if ownerRevision is present and oldRevision is not present
      else if (this.ownerRevision && !this.oldRevision) {
        console.log('Condition met for printing the document.');
        this.printDoc();
      }
      // Check if we can print a sample watermark or if oldRevision is present and watermark revision history can be printed
      else if (this.canPrintSampleWatermark || (this.oldRevision && this.canPrintWatermarkRevisionHistory)) {
        console.log('Condition met for printing document with sample watermark.');
        this.printDocSampleWatermark();
      }
      else {
        if (this.canPrint) {
          console.log('Condition met for printing the document.');
          this.printDoc();
        }
        else {
          console.log('No conditions met for printing.');
        }
      }
    },

    async download() {
      // Log the relevant properties for debugging
      console.log('canDownload:', this.canDownload);
      console.log('oldRevision:', this.oldRevision);
      console.log('ownerRevision:', this.ownerRevision);

      // Check if canDownload is true and oldRevision is available
      if (this.canDownload && this.oldRevision) {
        console.log('Condition met: Downloading watermark document.');
        this.downloadWatermarkDoc();
      }
      // Check if canDownload is true and ownerRevision is available
      else if (this.canDownload && this.ownerRevision) {
        console.log('Condition met: Downloading document.');
        this.downloadDoc();
      }
      // If neither of the above conditions are met, fallback to downloading watermark document
      else {
        console.log('No conditions met for downloading document. Defaulting to watermark document download.');
        this.downloadWatermarkDoc();
      }
    },

    async printDoc() {
      this.openPdfFromBase64(this.url, true);
    },

    async printDocSampleWatermark() {
      let rev = this.revisionData;

      const obj = {
        ...rev.revision,
        server: 'CVALE',
        user: rev.infos.user.name,
        userEmail: rev.infos.user.email
      };

      let response = await this.axios.get(
        `${process.env.VUE_APP_QUALIDOC_DDV4_API}/viewer/watermark`,
        { params: obj }
      );

      this.openPdfFromBase64(response.data, true);
    },

    async printDocWatermark() {
      let rev = this.revisionData;

      const obj = {
        ...rev.revision,
        server: 'CVALE',
        user: rev.infos.user.name,
        userEmail: rev.infos.user.email
      };

      let response = await this.axios.get(
        `${process.env.VUE_APP_QUALIDOC_DDV4_API}/viewer/watermark/uncontrolled-copy`,
        { params: obj }
      );

      this.openPdfFromBase64(response.data, true);
    },

    openPdfFromBase64(base64, isPrint = false) {
      let byte = atob(base64);
      let arr = Uint8Array.from(byte, c => c.charCodeAt(0));
      let blob = new Blob([arr], { type: "application/pdf" });
      let url = URL.createObjectURL(blob);

      if (isPrint) {
        let ifr = document.createElement("iframe");
        ifr.style.display = "none";
        ifr.src = url;
        document.body.appendChild(ifr);

        ifr.onload = () => {
          ifr.contentWindow.print();
        };
      } else {
        window.open(url, "_blank");
      }
    },

    downloadDoc() {
      this.openPdfFromBase64(this.url, false);
    },

    async downloadWatermarkDoc() {
      let rev = this.revisionData;

      const obj = {
        ...rev.revision,
        server: 'CVALE',
        user: rev.infos.user.name,
        userEmail: rev.infos.user.email
      };

      let response = await this.axios.get(
        `${process.env.VUE_APP_QUALIDOC_DDV4_API}/viewer/watermark/uncontrolled-copy`,
        { params: obj }
      );

      this.openPdfFromBase64(response.data, false);
    }
  }
};
</script>

<style scoped>
#HViewer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5em;
  background: #4285f4;
}

#HViewer .HVContent {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90%;
  margin-top: 0.3em;
}

#HViewer .HVContent .HVCompanyMarca {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 15%;
  height: 80%;
  padding: 0.5em 0;
  margin-top: 0.5em;
}

#HViewer .HVContent .HVCompanyMarca img {
  max-width: 100%;
  max-height: 100%;
}

#HViewer .HVContent .HVCompanyMarca img.logoCompany:hover {
  cursor: pointer;
}

#HViewer .HVContent .HVDocumentName {
  display: flex;
  flex-direction: row;
  width: 65%;
  font-size: 1.8em;
  color: #fff;
  padding-left: 0.5em;
}

#HViewer .HVContent .HVToolbarButtons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 80%;
  padding-right: 1em;
}

#HViewer .HVContent .HVToolbarButtons button {
  outline: 0;
  background: transparent !important;
  border: 1px solid #4285f4;
  border-radius: 0.4em;
  margin-right: 0.5em;
  color: #fefefe;
  font-size: 2em;
  font-weight: bold;
  padding: 0.3em 0.6em;
}

#HViewer .HVContent .HVToolbarButtons button:hover {
  cursor: pointer;
  background: #3a75d6 !important;
  border: 1px solid #1b689e;
}

#HViewer .HVContent .mg-right {
  margin-right: 1em;
}

@media print {
  #HViewer {
    display: none;
  }
}
</style>